import React from 'react';
import {twMerge} from 'tailwind-merge';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

export const BaseButton: React.FC<React.PropsWithChildren<Props>> = ({className, children, ...props}) => {
    return (
        <button
            {...props}
            className={twMerge(
                'box-border h-9 rounded-xl bg-black px-4 py-1 hover:bg-black/80',
                "flex items-center justify-center font-['Inter'] text-[13px] text-white",
                'transition duration-200 ease-in-out',
                className
            )}
        >
            {children}
        </button>
    );
};
